module.exports = __webpack_public_path__ + "static/img/guide-37.beae140f.png";